import styled from 'styled-components';

export const ContentWrapper = styled.div`
    max-width: 600px;
    width: 90%;
    margin: 0 auto;
`;
